/**
 * throttle — when to try again, and how long to wait.
 *
 * Extracted from spClient so a caller can back off without importing the
 * client, and with it the whole app config. outboxWrite talks to Graph rather
 * than SharePoint and needs exactly this policy and none of that: pulling in
 * spClient just for two pure functions made a Graph helper fail to load
 * anywhere the SharePoint env vars are not set.
 *
 * spClient re-exports both, so every existing import still works.
 */

/** SharePoint and Graph statuses worth retrying: 429/503 = throttled,
 * 500/504 = the server buckling under bulk load — both usually transient. */
export function isRetryableStatus(status: number): boolean {
  return status === 429 || status === 503 || status === 500 || status === 504;
}

/** How long to wait before the next attempt — honours the server's own
 * Retry-After (seconds) when it sends one, otherwise exponential backoff
 * with jitter so a burst of concurrent callers doesn't all retry in
 * lockstep and re-trigger the same throttle. */
export function backoffMs(attempt: number, retryAfterHeader: string | null): number {
  const retryAfter = Number(retryAfterHeader) || 0;
  return retryAfter > 0 ? retryAfter * 1000 : Math.min(500 * 2 ** (attempt - 1), 12000) + Math.random() * 400;
}
